import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { KeyRound, Music } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function ChangePasswordPage() {
  const { changePassword, user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const newPwd = watch('newPassword');

  const onSubmit = async ({ currentPassword, newPassword }) => {
    setLoading(true);
    try {
      await changePassword(currentPassword, newPassword);
      toast.success('Password changed! Please login again.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <div className="login-logo-icon" style={{ background: 'linear-gradient(135deg,#f97316,#c95605)' }}>
            <KeyRound size={28} />
          </div>
          <div className="login-title">Set New Password</div>
          <div className="login-sub">
            {user?.isFirstLogin ? 'First login — please set a personal password' : 'Change your password'}
          </div>
        </div>

        {user?.isFirstLogin && (
          <div className="alert alert-warning" style={{ marginBottom: 20, fontSize: 12 }}>
            <span>⚠️</span>
            <span>You are using a temporary password. Set a new one to continue.</span>
          </div>
        )}

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label className="form-label">Current / Temporary Password <span className="req">*</span></label>
            <input
              className={`form-control ${errors.currentPassword ? 'error' : ''}`}
              type="password"
              {...register('currentPassword', { required: 'Required' })}
            />
            {errors.currentPassword && <p className="form-error">{errors.currentPassword.message}</p>}
          </div>

          <div className="form-group">
            <label className="form-label">New Password <span className="req">*</span></label>
            <input
              className={`form-control ${errors.newPassword ? 'error' : ''}`}
              type="password"
              placeholder="Min 8 characters"
              {...register('newPassword', {
                required: 'Required',
                minLength: { value: 8, message: 'At least 8 characters' },
              })}
            />
            {errors.newPassword && <p className="form-error">{errors.newPassword.message}</p>}
          </div>

          <div className="form-group">
            <label className="form-label">Confirm New Password <span className="req">*</span></label>
            <input
              className={`form-control ${errors.confirmPassword ? 'error' : ''}`}
              type="password"
              {...register('confirmPassword', {
                required: 'Required',
                validate: v => v === newPwd || 'Passwords do not match',
              })}
            />
            {errors.confirmPassword && <p className="form-error">{errors.confirmPassword.message}</p>}
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ width: '100%', justifyContent: 'center', padding: '11px', marginTop: 4 }}
          >
            {loading ? 'Updating…' : 'Update Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
